import(/* webpackMode: "eager" */ "/home/interim/frontend/app/blog/page.tsx");
